import React from 'react';
import downloadIcon from '../../images/download.svg';
import shareIcon from '../../images/share.svg';
import filterIcon from '../../images/filter.svg';
import searchIcon from '../../images/search.svg';
export const TableController = (props) => {
	const { openModal } = props;
	return (
		<div className="share-mobile mobile-only pt-0 mb-8">
			<div className="container flex justify-between w-full">
				<div className="share-mobile__wrapper">
					<a
						href="#"
						onClick={openModal('filter')}
						className="share-mobile__btn"
					>
						<img
							src={filterIcon}
							alt=""
							className="share-mobile__btn-icon"
						/>
					</a>
					<a
						href="#"
						onClick={openModal('search')}
						className="share-mobile__btn"
					>
						<img
							src={searchIcon}
							alt=""
							className="share-mobile__btn-icon"
						/>
					</a>
				</div>
				<div className="share-mobile__wrapper">
					<a
						href="#"
						onClick={openModal('download')}
						className="share-mobile__btn"
					>
						<img
							src={downloadIcon}
							alt=""
							className="share-mobile__btn-icon"
						/>
					</a>
					<a
						href="#"
						onClick={openModal('share')}
						className="share-mobile__btn"
					>
						<img
							src={shareIcon}
							alt=""
							className="share-mobile__btn-icon"
						/>
					</a>
				</div>
			</div>
		</div>
	);
};
